import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Fonts are bundled from npm rather than fetched from Google Fonts at runtime —
// fonts.googleapis.com is unreliable from Russia, where this app is used.
import '@fontsource-variable/manrope';
import '@fontsource-variable/source-sans-3';

import { App } from './App.tsx';
import { AuthProvider } from './auth/AuthContext.tsx';
import './styles/base.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
